export class ApiError extends Error {}
export class UnauthorizedApiError extends ApiError {}
export class ServerApiError extends ApiError {}

export class ValidationError extends Error {}
export class UserIdValidationError extends ValidationError {}
